import { render, staticRenderFns } from "./AddProductSlot.vue?vue&type=template&id=503f53c6"
import script from "./AddProductSlot.vue?vue&type=script&lang=ts"
export * from "./AddProductSlot.vue?vue&type=script&lang=ts"
import style0 from "./AddProductSlot.vue?vue&type=style&index=0&id=503f53c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports